import React from 'react';
import Modal from 'react-modal';
import modal from '../../../definitions/Modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import OTButton from '../../tag/OTButton';

const { id: module_id } = module;

const notificationModal = modal({
  content: { padding: '30px 20px', fontSize: '18px' },
});

const LibreviewContinueModal = ({
  isOpen,
  closeModal,
  redirectToLibreView,
}) => {
  const handleContinueClicked = () => {
    redirectToLibreView();
    closeModal();
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={notificationModal}
    >
      <div className="row-fluid libreviewModal">
        <h4>
          <FormattedMessage id={`${module_id}.queryHeading`} />
        </h4>
      </div>
      <div className="row-fluid libreviewModalBtn">
        <OTButton className="ot-button--gray" onClick={closeModal}>
          <FormattedMessage id={'cancel'} />
        </OTButton>
        <OTButton onClick={handleContinueClicked}>
          <FormattedMessage id={'continue'} />
        </OTButton>
      </div>
    </Modal>
  );
};

export default injectIntl(LibreviewContinueModal);
